import React, { useCallback, useEffect, useState } from 'react'
import { Avatar, CircularProgress, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import { usePericiandoService } from 'hooks/usePericiandoService'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { BaseCard } from 'components'

const useStyles = makeStyles((theme) => ({
  carregando: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3),
  },
}))

export const CardRegistroIdentificacao = (props) => {
  const classes = useStyles()
  moment.locale('pt-br', localization)
  const periciandoService = usePericiandoService()
  const { idRegistro } = props
  const [registroIdentificacao, setRegistroIdentificacao] = useState({})
  const [processandoRegistro, setProcessandoRegistro] = useState(false)

  const fetchRegistro = useCallback(async () => {
    if (idRegistro) {
      const response = await periciandoService.listarRegistroIdentificacaoAsync(idRegistro, setProcessandoRegistro)
      setRegistroIdentificacao(response)
    }
  }, [idRegistro])

  useEffect(() => {
    fetchRegistro()
  }, [fetchRegistro])

  if (processandoRegistro || !registroIdentificacao) {
    return (
      <div className={classes.carregando}>
        <CircularProgress disableShrink />
      </div>
    )
  }

  const avatar = (
    <Avatar style={{ backgroundColor: '#00008B' }}>
      <AssignmentIndIcon />
    </Avatar>
  )

  return (
    <BaseCard
      avatar={avatar}
      title={`Registro - Protocolo ${registroIdentificacao.numeroProtocolo || '-'}`}
      tabular={false}
    >
      <Grid container justifyContent="space-between" spacing={2}>
        <Grid item md={6} sm={6} xs={12}>
          <Typography variant="h7">
            <b>CPF</b>
          </Typography>
          <Typography variant="body2">
            {registroIdentificacao.cpf?.toUpperCase() || 'NÃO INFORMADO'}
          </Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography variant="h7">
            <b>RG</b>
          </Typography>
          <Typography variant="body2">
            {registroIdentificacao.rg?.toUpperCase() || 'NÃO INFORMADO'}
          </Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography variant="h7">
            <b>NOME</b>
          </Typography>
          <Typography variant="body2">
            {registroIdentificacao.nome?.toUpperCase() || 'NÃO INFORMADO'}
          </Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography variant="h7">
            <b>ALCUNHA</b>
          </Typography>
          <Typography variant="body2">
            {registroIdentificacao.alcunha?.toUpperCase() || 'NÃO INFORMADO'}
          </Typography>
        </Grid>

        <Grid item md={6} sm={6} xs={12}>
          <Typography variant="h7">
            <b>FILIAÇÕES</b>
          </Typography>
          <Typography variant="body2">
            {registroIdentificacao.filiacoes?.map((filiacao) => filiacao?.toUpperCase() || '')?.join(', ') || 'NÃO INFORMADO'}
          </Typography>
        </Grid>

        <Grid item md={6} sm={6} xs={12}>
          <Typography variant="h7">
            <b>NACIONALIDADE</b>
          </Typography>
          <Typography variant="body2">
            {registroIdentificacao.nacionalidade?.toUpperCase() || 'NÃO INFORMADO'}
          </Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography variant="h7">
            <b>NATURALIDADE</b>
          </Typography>
          <Typography variant="body2">
            {registroIdentificacao.naturalidade?.toUpperCase() || 'NÃO INFORMADO'}
          </Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography variant="h7">
            <b>SEXO</b>
          </Typography>
          <Typography variant="body2">
            {registroIdentificacao.sexo?.toUpperCase() || 'NÃO INFORMADO'}
          </Typography>
        </Grid>
      </Grid>
    </BaseCard>
  )
}
